import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api; bearer: string };
type HookTuple = [
  response: vp.FetchAccountUsersApiResponse,
  fetchData: (params: vp.TimezoneRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const useFetchAccountUsers: ApiHook = ({ api, bearer }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [response, setResponse] = useState<vp.FetchAccountUsersApiResponse>({
    Success: false,
    ErrorMessage: '',
    Users: [],
  });
  const [shouldFetchData, setShouldFetchData] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.TimezoneRequest>({});

  useEffect(() => {
    if (!shouldFetchData) return () => {};

    const loadData = async () => {
      setDataFetchingInfo(true, 'Loading Data', 'fullScreen');
      const res = await api.fetchAccountUsers(params, bearer, source);
      setResponse(res);

      setDataFetchingInfo(false);
    };

    if (shouldFetchData) void loadData();
    setShouldFetchData(false);

    return () => {
      source.cancel();
    };
  }, [shouldFetchData]);

  return [
    response,
    () => {
      setParams(params);
      setShouldFetchData(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        Users: [],
      });
      setShouldFetchData(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchAccountUsers);
